module.exports = __webpack_public_path__ + "img/footer_down.f6dd2555.png";